import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "assessment-details__nav" }
const _hoisted_2 = {
  key: 0,
  class: "assessment-details__buttons"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-prev-arrow" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-next-arrow" }, null, -1)
const _hoisted_5 = { class: "assessment-details__grid" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-prev-arrow" }, null, -1)
const _hoisted_7 = { class: "assessment-details__date" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-next-arrow" }, null, -1)
const _hoisted_9 = { class: "assessment-details__info" }
const _hoisted_10 = {
  key: 0,
  class: "assessment-details__date"
}
const _hoisted_11 = { class: "assessment-details__results" }
const _hoisted_12 = { class: "results-report" }
const _hoisted_13 = { class: "results-report-entry__header" }
const _hoisted_14 = { class: "results-report-entry__name" }
const _hoisted_15 = { class: "results-report-entry__description" }
const _hoisted_16 = {
  key: 0,
  class: "assessment-details__milestone-planner-action"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxGrid = _resolveComponent("PxGrid")!
  const _component_PxBadge = _resolveComponent("PxBadge")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    ref: "modal",
    modelValue: _ctx.innerVisibility,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.innerVisibility) = $event)),
    title: _ctx.$t('profile.assessmentDetails.title'),
    class: "assessment-details"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ElSelect, {
          modelValue: _ctx.currentSelectAssessment,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentSelectAssessment) = $event)),
          disabled: !_ctx.hasMultipleAssessments,
          class: "assessment-details__select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessmentList, (assessment, key) => {
              return (_openBlock(), _createBlock(_component_ElOption, {
                key: key,
                label: _ctx.assessmentTitle(assessment, key),
                value: key
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.assessmentTitle(assessment, key)), 1)
                ]),
                _: 2
              }, 1032, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        (_ctx.$screen.mdUp && _ctx.hasMultipleAssessments)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_PxButton, {
                disabled: _ctx.onOldestAssessment,
                class: "assessment-details__arrow",
                onClick: _ctx.prevAssessment
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_PxButton, {
                disabled: _ctx.onLatestAssessment,
                class: "assessment-details__arrow",
                onClick: _ctx.nextAssessment
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PxGrid, {
          categories: _ctx.categories,
          "current-level": _ctx.currentAssessmentLevelValue,
          levels: _ctx.numOfLevels,
          results: _ctx.assessmentResults,
          size: _ctx.gridSize
        }, null, 8, ["categories", "current-level", "levels", "results", "size"]),
        (_ctx.$screen.mdDown)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{
          'assessment-details__mobile-nav--center': !_ctx.hasMultipleAssessments,
        }, "assessment-details__mobile-nav"])
            }, [
              (_ctx.hasMultipleAssessments)
                ? (_openBlock(), _createBlock(_component_PxButton, {
                    key: 0,
                    disabled: _ctx.onOldestAssessment,
                    class: "assessment-details__arrow",
                    onClick: _ctx.prevAssessment
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("profile.assessmentDetails.date")) + " " + _toDisplayString(_ctx.formattedDate(_ctx.currentAssessmentDate)), 1),
              (_ctx.hasMultipleAssessments)
                ? (_openBlock(), _createBlock(_component_PxButton, {
                    key: 1,
                    disabled: _ctx.onLatestAssessment,
                    class: "assessment-details__arrow",
                    onClick: _ctx.nextAssessment
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.$screen.mdUp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("profile.assessmentDetails.date")) + " " + _toDisplayString(_ctx.formattedDate(_ctx.currentAssessmentDate)), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_PxButton, {
            class: "el-button--link el-button--link-dark el-button--small",
            icon: "icon-information",
            type: "link",
            onClick: _ctx.onClickOpenHowItWorksLink
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("profile.assessment.gridPanel.moreLink")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
            return (_openBlock(), _createElementBlock("div", {
              key: category.id,
              class: _normalizeClass([{
            'results-report-entry--not-achieved':
              _ctx.levelForCategory(category) === 0,
          }, "results-report-entry"])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_PxBadge, {
                  color: _ctx.getCategoryColor(category),
                  value: _ctx.levelForCategory(category),
                  class: "results-report-entry__level"
                }, null, 8, ["color", "value"]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(category.name), 1)
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.selectedLevelDescription(category)), 1)
            ], 2))
          }), 128))
        ])
      ]),
      (_ctx.showMilestonePlannerCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("profile.milestonePlannerAction.title")), 1),
            _createVNode(_component_PxButton, {
              size: "small",
              type: "green",
              onClick: _ctx.goToMilestonePlannerPage
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("profile.milestonePlannerAction.cta")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}